import { useEffect, useRef, useState } from "react";
import ProductCard from "@/components/ProductCard";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ProductCarousel({ title, products, testid }) {
  const trackRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const updateArrows = () => {
    const el = trackRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    updateArrows();
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    return () => { el.removeEventListener("scroll", updateArrows); window.removeEventListener("resize", updateArrows); };
  }, [products]);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.round(el.clientWidth * 0.85), behavior: "smooth" });
  };

  if (!products?.length) return null;

  return (
    <section data-testid={testid} className="mb-12">
      <h2 className="text-2xl font-bold mb-5 text-steel">{title}</h2>
      <div className="relative">
        {canLeft && (
          <button data-testid={`${testid}-left`} onClick={() => scrollBy(-1)} aria-label="Scroll left"
            className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 grid place-items-center w-11 h-11 rounded-full bg-white shadow-md border hover:bg-accent hover:text-steel transition-colors">
            <ChevronLeft size={24} />
          </button>
        )}
        <div ref={trackRef}
          className="flex gap-3 sm:gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {products.map((p) => (
            <div key={p.id} className="shrink-0 snap-start basis-[calc((100%-0.75rem)/2)] sm:basis-[calc((100%-2rem)/3)] md:basis-[calc((100%-3rem)/4)] lg:basis-[calc((100%-4rem)/5)] xl:basis-[calc((100%-5rem)/6)]">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
        {canRight && (
          <button data-testid={`${testid}-right`} onClick={() => scrollBy(1)} aria-label="Scroll right"
            className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 grid place-items-center w-11 h-11 rounded-full bg-white shadow-md border hover:bg-accent hover:text-steel transition-colors">
            <ChevronRight size={24} />
          </button>
        )}
      </div>
    </section>
  );
}
